import { Dispatch, SetStateAction, useCallback } from 'react'
import { ScheduleType } from 'types/schedule'

const useChoices = (setSchedules: Dispatch<SetStateAction<ScheduleType[]>>) => {
  const addChoice = useCallback(
    () =>
      setSchedules((prevState) => {
        const nextState = prevState.map((schedule) => {
          schedule.choices.push('')
          return schedule
        })
        return [...nextState]
      }),
    [setSchedules]
  )

  const clearChoices = useCallback(
    () =>
      setSchedules((prevState) => {
        const nextState = prevState.map((schedule) => {
          schedule.choices = []
          return schedule
        })
        return [...nextState]
      }),
    [setSchedules]
  )

  const deleteChoice = useCallback(
    (choiceIndex: number) =>
      setSchedules((prevState) => {
        const nextState = prevState.map((schedule) => {
          schedule.choices = schedule.choices.filter((_, index) => index !== choiceIndex)
          return schedule
        })
        return [...nextState]
      }),
    [setSchedules]
  )

  const handleChoices = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, index: number) =>
      setSchedules((prevState) => {
        const nextState = prevState.map((schedule) => {
          schedule.choices[index] = event.target.value
          return schedule
        })
        return [...nextState]
      }),
    [setSchedules]
  )

  const initChoices = useCallback(
    () =>
      setSchedules((prevState) => {
        const nextState = prevState.map((schedule) => {
          schedule.choices = ['']
          return schedule
        })
        return [...nextState]
      }),
    [setSchedules]
  )

  return {
    addChoice,
    clearChoices,
    deleteChoice,
    handleChoices,
    initChoices,
  }
}

export default useChoices
